import {isPlaceholderPotId} from '../features/builder/CreateBuilder/BuilderSourceDestination/builderConstants';
import {Pot} from '../schema-types/Pot';
import {PotDetails} from '../schema-types/PotDetails';

export const LOA_REQUIRED = 'LOA required';

export enum PotInfo {
  brandNewPot = 'Brand New Pot',
  existingNewPotByOtherRec = 'Existing New Pot By Other Rec',
  existingNewPotThisRec = 'Existing New Pot This Rec',
  existingShellPlanThisRec = 'Existing Shell Plan This Rec',
  existingShellPlanByOtherRec = 'Existing Shell Plan By Other Rec',
  newShellPlan = 'New Shell Plan',
  newCashContribution = 'New Cash Contribution',
  existingCashContribution = 'Existing Cash Contribution',
  bankAccount = 'Bank Account',
  existingPlan = 'Existing Plan',
}

export const isWrapperPot = (pot: Pot): boolean => !!pot.children && !pot.parent;

export const isSubplanPot = (pot: Pot): boolean => !pot.children && !!pot.parent;

export const getPotInfo = (pot: PotDetails, originalOvrId?: string): PotInfo => {
  // brand new pot
  if (isPlaceholderPotId(pot.id)) {
    return PotInfo.brandNewPot;
  }

  // existing shell plan
  if (
    pot.isShellPlan ||
    pot.servicingRights === LOA_REQUIRED ||
    pot.servicingRights === 'No information rights'
  ) {
    if (originalOvrId && pot.originalOvrId === originalOvrId) {
      return PotInfo.existingShellPlanThisRec;
    }
    return PotInfo.existingShellPlanByOtherRec;
  }

  // existing new pot this recommendation
  if (pot.isDummy && !!originalOvrId && pot.originalOvrId === originalOvrId) {
    return PotInfo.existingNewPotThisRec;
  }

  // existing new pot by other recommendation
  if (pot.isDummy && pot.productName && pot.productProvider) {
    return PotInfo.existingNewPotByOtherRec;
  }

  // new shell plan
  if (pot?.id?.includes('shell')) {
    return PotInfo.newShellPlan;
  }

  // new cash contribution
  if (pot.id === 'cash') {
    return PotInfo.newCashContribution;
  }

  // existing cash contribution
  if (pot.isDummy && (!pot.productName || !pot.productProvider)) {
    return PotInfo.existingCashContribution;
  }

  return PotInfo.existingPlan;
};
